import Vue from "vue";

const setMortgage = (context, mortgage) => {
  context.mortgage = mortgage;
};

const setMortgageParts = (context, mortgageParts) => {
  context.mortgageParts = mortgageParts;
};

const syncMortgageByKeyAndValue = (context, { key, value }) => {
  context.mortgage[key] = value;
};

const removeMortgagePartByIndex = (context, index) => {
  context.mortgageParts.splice(index, 1);
};

const addMortgagePart = (context, mortgagePart) => {
  if (context.mortgageParts === null) {
    context.mortgageParts = [mortgagePart];
  } else {
    context.mortgageParts.push(mortgagePart);
  }
};

const addMortgageErrors = (context, errors) => {
  context.mortgage = { ...context.mortgage, errors };
};

const addMortgagePartErrors = (context, { index, errors }) => {
  if (Object.hasOwn(errors, "mortgage_id")) {
    delete errors.mortgage_id;
  }

  Vue.set(context.mortgageParts, index, { ...context.mortgageParts[index], errors });
};

const addMortgageProperty = (context, propertyId) => {
  context.mortgageProperties.push(propertyId);
};

const removeMortgageProperty = (context, propertyId) => {
  if (Array.isArray(context.mortgageProperties)
      && context.mortgageProperties.includes(propertyId)) {
    context.mortgageProperties = context.mortgageProperties.filter((id) => id !== propertyId);
  }
};

export default {
  setMortgage,
  setMortgageParts,
  syncMortgageByKeyAndValue,
  addMortgagePart,
  removeMortgagePartByIndex,
  addMortgageErrors,
  addMortgagePartErrors,
  addMortgageProperty,
  removeMortgageProperty,
};
